// Unified color scheme for TheFastestForm
// Using more subtle, professional colors

export const colors = {
  // Primary actions (save, submit, confirm)
  primary: {
    50: 'bg-brand-50',
    100: 'bg-brand-100', 
    500: 'bg-brand-500',
    600: 'bg-brand-600',
    700: 'bg-brand-700',
    text: {
      50: 'text-brand-50',
      100: 'text-brand-100',
      500: 'text-brand-500', 
      600: 'text-brand-600',
      700: 'text-brand-700',
      800: 'text-brand-800',
    },
    border: {
      200: 'border-brand-200',
      300: 'border-brand-300',
      500: 'border-brand-500',
    }
  },
  
  // Secondary actions (edit, update, modify)
  secondary: {
    50: 'bg-slate-50',
    100: 'bg-slate-100',
    500: 'bg-slate-500', 
    600: 'bg-slate-600',
    700: 'bg-slate-700',
    text: {
      50: 'text-slate-50',
      100: 'text-slate-100',
      500: 'text-slate-500',
      600: 'text-slate-600',
      700: 'text-slate-700',
      800: 'text-slate-800',
    },
    border: {
      200: 'border-slate-200',
      300: 'border-slate-300',
    }
  },

  // Danger actions (delete, remove, logout)
  danger: {
    50: 'bg-rose-50',
    100: 'bg-rose-100',
    500: 'bg-rose-500',
    600: 'bg-rose-600', 
    700: 'bg-rose-700',
    text: {
      50: 'text-rose-50',
      100: 'text-rose-100',
      500: 'text-rose-500',
      600: 'text-rose-600',
      700: 'text-rose-700',
      800: 'text-rose-800',
    },
    border: {
      200: 'border-rose-200',
      300: 'border-rose-300',
    }
  },

  // Accent/highlight (active states, selections)
  accent: {
    50: 'bg-amber-50',
    100: 'bg-amber-100',
    500: 'bg-amber-500',
    600: 'bg-amber-600',
    700: 'bg-amber-700',
    text: {
      50: 'text-amber-50',
      100: 'text-amber-100',
      500: 'text-amber-500',
      600: 'text-amber-600',
      700: 'text-amber-700',
      800: 'text-amber-800',
    },
    border: {
      200: 'border-amber-200',
      300: 'border-amber-300',
    }
  }
};

// Button component classes for consistency
export const buttonStyles = {
  primary: `px-4 py-2 ${colors.primary[600]} text-white rounded-md hover:${colors.primary[700]} disabled:opacity-50 disabled:cursor-not-allowed transition-colors`,
  secondary: `px-4 py-2 ${colors.secondary[600]} text-white rounded-md hover:${colors.secondary[700]} disabled:opacity-50 disabled:cursor-not-allowed transition-colors`,
  danger: `px-4 py-2 ${colors.danger[600]} text-white rounded-md hover:${colors.danger[700]} disabled:opacity-50 disabled:cursor-not-allowed transition-colors`,
  outline: `px-4 py-2 border border-gray-300 text-gray-700 bg-white rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors`,
  
  // Size variants
  small: `px-3 py-1 text-sm`,
  large: `px-6 py-3 text-base`,
  
  // Width variants
  full: `w-full`,
  auto: `w-auto`,
};
